import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';
import { getStayTeaserBookingFragment } from 'Views/account/queries/account.queries';
// QUICKDASHBOARD
export const getQuickDashboardQueries = (bookingId: string, appContext: AppContext) => {
  return `
    query {
      customerBooking(id: "${bookingId}") {
        ...booking
      }
    }
    ${getStayTeaserBookingFragment(appContext, {
      withUpsells: true,
    })}
    `;
};
// DASHBOARD
export const getOptionByIdQuery = (bookingId: string, appContext: AppContext) => `query {
  customerBooking(id: "${bookingId}") {
    ...booking
  }
}
${getStayTeaserBookingFragment(appContext, {
  withUpsells: false,
})}
`;

const getOptionFilter = (appContext: AppContext) => {
  const base = ['"OPTION"'];
  return isFeatureFlipped(appContext)('memberSpace.enableOptionRenewal')
    ? [...base, '"EXPIRED"']
    : base;
};

export const getFutureBookingsQuery = (appContext: AppContext) => `query { 
    customers(byPassGetCustomer: true) {
      futureTrips {
        count
        trips(status: ["VALIDATED"]) {
          data {
            ...booking
          }
        }
        options: trips(status: [${getOptionFilter(appContext).join(',')}]){
          data {
            ...booking
          }
        }
      }
    }
  }
  ${getStayTeaserBookingFragment(appContext, {
    withUpsells: true,
  })}
  `;
export const getCurrentBookingsQuery = (appContext: AppContext) => `query { 
    customers(byPassGetCustomer: true) {
      currentTrips {
        count
        trips {
          data {
            ...booking
          }
        }
      }
    }
  }
  ${getStayTeaserBookingFragment(appContext, {
    withUpsells: false,
  })}
  `;
export const sendRequestPickYourRoomResortOnly = ({
  bookingId,
  comment,
  criteria,
}: {
  bookingId: string;
  comment: string;
  criteria: string;
}) => {
  return `mutation {
    sendRequestPickYourRoomResortOnly(bookingId: "${bookingId}", criteria: "${criteria}", comment:"${comment}")
  }`;
};
